import { render } from "./ProjectAnalysisBenchmarkingMessages.vue?vue&type=template&id=432a6934"
import script from "./ProjectAnalysisBenchmarkingMessages.vue?vue&type=script&lang=js"
export * from "./ProjectAnalysisBenchmarkingMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__